import React, { useState, useEffect } from "react";
import {BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Authenticated from "./Authenticated";
import Map from "./Map"
import Admin from "./Admin"
import Login from "./Login"


function App() {
  
  useEffect(()=>{

  }, [])

  return (
    <>
      <Router>
        <Routes>
          <Route element={<Authenticated/>}>
            <Route path="/admin"  element={<><Admin/></>} />
          </Route>
          <Route path="/login"  element={<><Login/></>} />
          
          <Route path="*"  element={<><Map/></>} />
        </Routes>
    </Router>
    
    </>
  );
}

export default App;

